import { OrderStatus } from '@src/orders/domain/Order';
import { OrderTab } from '@src/orders/domain/OrderTab';
import { useOrdersWithFilters } from '@src/orders/hooks/useOrdersWithFilters';

export const useGetNewOrdersForClient = (
  clientId: string,
  enabled?: boolean,
) => {
  const { orders, isLoading } = useOrdersWithFilters({
    assignedToMe: false,
    page: 1,
    pageSize: 1,
    category: OrderTab.New,
    status: OrderStatus.NEW,
    clientId,
    enabled,
  });

  return {
    hasNewOrders: orders.totalOrders > 0,
    newOrdersCount: orders.totalOrders,
    isLoading,
  };
};
